/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import {
  Segment, Form,
  Popup, Divider, Button, Dimmer,
  Loader, Icon, Input, Grid,
  Container, Checkbox, Header
} from "semantic-ui-react";

import { withRouter } from "react-router-dom";

import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

const getDefaultFiberProcessState = () => ({ isFiberProcessOn: false });
const getDefaultFiberLimit = () => ({
  fiberLowerLimitUrgentMaintenance: "",
  fiberLowerLimitMaintenanceRequired: ""
});

export const normalizeFiberChannelActive = (fiberChannelActive) => ({
  FB1: {
    channel2Active: false,
    channel3Active: false,
    signalActive: false,
    ...(fiberChannelActive && typeof fiberChannelActive.FB1 === "object" ? fiberChannelActive.FB1 : {})
  }
});

export class OpticFiberConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      signalActive: false,
      channel2Active: false,
      channel3Active: false,
      // Limites
      fiberLowerLimitUrgentMaintenance: "",
      fiberLowerLimitMaintenanceRequired: "",
      //
      channel2: "",
      channel3: "",
      signal: "",
      // Dimmers
      isFiberChannelActiveDimmerActive: false,
      isIntervalsDimmerActive: false,
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/isFiberProcessOn", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .catch(() => getDefaultFiberProcessState())
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberChannelActive", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(normalizeFiberChannelActive)
        .catch(() => normalizeFiberChannelActive())
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberLimit", { mode: "cors" })
        .then(UtilsInstance.checkStatus)
        .then(res => res.json())
        .then(data => data)
        .catch(() => getDefaultFiberLimit())
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      isFiberProcessOn: resolvedPromisses[0].isFiberProcessOn,
      //
      signalActive: resolvedPromisses[1].FB1.signalActive,
      channel2Active: resolvedPromisses[1].FB1.channel2Active,
      channel3Active: resolvedPromisses[1].FB1.channel3Active,
      // Limites
      fiberLowerLimitUrgentMaintenance: resolvedPromisses[2].fiberLowerLimitUrgentMaintenance,
      fiberLowerLimitMaintenanceRequired: resolvedPromisses[2].fiberLowerLimitMaintenanceRequired,
    });
  }

  handlefiberLowerLimitUrgentMaintenanceChange = (e, { value }) => {
    this.setState({ fiberLowerLimitUrgentMaintenance: value });
  }

  handlefiberLowerLimitMaintenanceRequiredChange = (e, { value }) => {
    this.setState({ fiberLowerLimitMaintenanceRequired: value });
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleSignalActiveChange = () => this.setState({ signalActive: !this.state.signalActive });
  handleFiberChannel1Change = () => this.setState({ channel2Active: !this.state.channel2Active });
  handleFiberChannel2Change = () => this.setState({ channel3Active: !this.state.channel3Active });

  handleFiberChannelActiveSubmit = () => {
    this.setState({ isFiberChannelActiveDimmerActive: true }, () => {
      fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberChannelActive_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({
          FB1: {
            signalActive: this.state.signalActive,
            channel2Active: this.state.channel2Active,
            channel3Active: this.state.channel3Active,
          }
        }),
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.SEND_CONFIG_SUCCESS);
          this.retrieveData();
        })
        .catch((error) => {
          alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + error);
        })
        .finally(() => {
          this.setState({ isFiberChannelActiveDimmerActive: false });
        });
    });
  }

  handleIntervalsSubmit = () => {
    const isValidNumber1 = Number.isFinite(parseFloat(this.state.fiberLowerLimitUrgentMaintenance));
    const isValidNumber2 = Number.isFinite(parseFloat(this.state.fiberLowerLimitMaintenanceRequired));

    if (isValidNumber1 && isValidNumber2) {

      if (this.state.fiberLowerLimitMaintenanceRequired > this.state.fiberLowerLimitUrgentMaintenance) {
        this.setState({ isIntervalsDimmerActive: true }, () => {

          fetch(Constants.REQUEST_IP_ADDRESS + "fiber/fiberLimit_POST", {
            method: "POST",
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            },
            body: JSON.stringify({ fiberLowerLimitMaintenanceRequired: this.state.fiberLowerLimitMaintenanceRequired, 
              fiberLowerLimitUrgentMaintenance: this.state.fiberLowerLimitUrgentMaintenance }),
            mode: "cors"
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              alert(Strings.SEND_CONFIG_SUCCESS);
              this.retrieveData();
            })
            .catch((error) => {
              alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + error);
            })
            .finally(() => {
              this.setState({ isIntervalsDimmerActive: false });
            });

        });
      } else {
        alert(Strings.DIVERGENCE_MAINTENANCE_VALUE);
      }
    }
    else {
      alert(Strings.INVALID_VALUE);
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Container>
        <Grid columns={2}>
          <Grid.Column>

            <Segment>
              <Divider horizontal>
                {Strings.OPTIC_FIBER}
                {/* <Popup position='bottom center' hoverable pinned wide
                  trigger={
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  }>
                  <Popup.Content>
                    <p> Explicação </p>
                  </Popup.Content>
                </Popup> */}
              </Divider>

              <Form style={formStyle} onSubmit={this.handleFiberChannelActiveSubmit}>
                <Form.Field>
                  <Checkbox
                    toggle
                    name="signalActive"
                    onClick={this.handleSignalActiveChange}
                    checked={this.state.signalActive}
                    label={Strings.RELAY_SIGNAL} />
                </Form.Field>

                <Form.Field style={{ marginRight: "1.5vw" }}>
                  <Checkbox
                    toggle
                    name="channel2Active"
                    onClick={this.handleFiberChannel1Change}
                    checked={this.state.channel2Active}
                    label={Strings.CHANNEL_2} />
                </Form.Field>

                <Form.Field style={{ marginRight: "1.5vw" }}>
                  <Checkbox
                    toggle
                    name="channel3Active"
                    onClick={this.handleFiberChannel2Change}
                    checked={this.state.channel3Active}
                    label={Strings.CHANNEL_3} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>

              </Form>

              <Dimmer active={this.state.isFiberChannelActiveDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>

          </Grid.Column>

          <Grid.Column>

            <Segment textAlign="center">
              <Divider horizontal>
                {Strings.MAINTENANCE_REQUIRED}
              </Divider>

              <Form style={formStyle} onSubmit={this.handleIntervalsSubmit}>

                <Form.Field inline>
                  <label>{Strings.STR_LIMIT}</label>
                  <Input
                    name="fiberLowerLimitMaintenanceRequired"
                    type="number"
                    placeholder='0.3'
                    label={{ basic: true, content: "V" }}
                    labelPosition='right'
                    value={this.state.fiberLowerLimitMaintenanceRequired}
                    onChange={this.handleChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>

              </Form>

              <Dimmer active={this.state.isIntervalsDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment textAlign="center">
              <Divider horizontal>
                {Strings.MAINTENANCE_URGENT}
                {/* <Popup position='bottom center' hoverable pinned wide
                  trigger={
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  }>
                  <Popup.Content>
                    <p> Explicação </p>
                  </Popup.Content>
                </Popup> */}
              </Divider>

              <Form style={formStyle} onSubmit={this.handleIntervalsSubmit}>

                <Form.Field inline>
                  <label>{Strings.STR_LIMIT}</label>
                  <Input
                    name="fiberLowerLimitUrgentMaintenance"
                    type="number"
                    placeholder='0.1'
                    label={{ basic: true, content: "V" }}
                    labelPosition='right'
                    value={this.state.fiberLowerLimitUrgentMaintenance}
                    onChange={this.handleChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>

              </Form>

              <Dimmer active={this.state.isIntervalsDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>

          </Grid.Column>
        </Grid>
      </Container>
    );
  }
}

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

// const questionIconStyle = {
//   marginLeft: "4px"
// };

export default withRouter(OpticFiberConfig);